import { Component, Input, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
    selector: 'app-alerts-diagnosis',
    templateUrl: './alerts-diagnosis.component.html',
    standalone: false
})
export class AlertsDiagnosisComponent implements OnInit {

  @Input()
  alerts: string[];

  constructor(private activeModal: NgbActiveModal) { }

  ngOnInit(): void {
  }

  close(){
    this.activeModal.close();
  }

}
